import { twMerge } from 'tailwind-merge';
import React, { useEffect } from 'react';
export const LanguageToggle = _ref => {
  let {
    onClickEnglish,
    onClickSpanish,
    language = 'english'
  } = _ref;
  useEffect(() => {
    if (language === 'spanish') document.documentElement.setAttribute('lang', 'sp');else document.documentElement.setAttribute('lang', 'en');
  }, [language]);
  return React.createElement("div", {
    "data-cy": "language-toggle",
    className: "mx-auto flex max-w-max justify-between rounded-full border"
  }, React.createElement("button", {
    "data-cy": "language-toggle-english",
    onClick: onClickEnglish,
    className: twMerge('px-6 py-3 text-xl rounded-l-full focus:outline-none', language === 'english' ? 'bg-ab-100 text-white' : 'text-slate-800 bg-blue-50')
  }, "English"), React.createElement("button", {
    "data-cy": "language-toggle-spanish",
    onClick: onClickSpanish,
    className: twMerge('px-6 py-3 text-xl rounded-r-full focus:outline-none', language === 'spanish' ? 'bg-ab-100 text-white' : 'text-slate-800 bg-blue-50')
  }, "Spanish"));
};